import type { PropsWithChildren, FC } from 'react';

import { RecipeVariants } from '@vanilla-extract/recipes';

import { svgIconRecipe } from './IconWrapper.css';
import { DynamicVariantProp } from '../types';
import { getClassNames } from '../util/css';

const ownClassName = 'icon-sparky';

export const Icon: FC<PropsWithChildren<IconProps>> = ({ children, color, size, verticalAlign = 'bottom' }) => {
  const iconClassNames = getClassNames(svgIconRecipe({ color, size, verticalAlign }), ownClassName);
  return (
    <svg aria-hidden="true" className={iconClassNames} viewBox="0 0 24 24">
      {children}
    </svg>
  );
};

export type IconProps = {
  verticalAlign?: Extract<
    DynamicVariantProp<'verticalAlign'>,
    'baseline' | 'top' | 'middle' | 'bottom' | 'sub' | 'super' | 'text-top' | 'text-bottom'
  >;
} & RecipeVariants<typeof svgIconRecipe>;

Icon.toString = () => `.${ownClassName}`;
